import { Button, Table, TableCell, TableHeaderCell, TableRow } from '@lokalise/louis';

import styled from '@app/styled';
import { mediaQuery, radius, spacing, transition, typography, value } from '@app/theme';

export const Container = styled.div`
    padding: ${spacing(0, 7)};
`;

export const TableContainer = styled(Table)`
    border-collapse: separate;
    border-spacing: ${spacing(0, 4)};
`;

export const TableHeadCellContainer = styled(TableHeaderCell)`
    border: none;
    text-transform: uppercase;
    color: ${value('color.custom.content.secondary')};
    ${typography('custom.tableHeader')}
`;

export const TableHeadStatusCellContainer = styled(TableHeadCellContainer)`
    ${mediaQuery.max('md')} {
        width: 100px;
    }
`;

export const TableHeadActionCellContainer = styled(TableHeadCellContainer)`
    width: 100px;
    ${mediaQuery.max('md')} {
        width: 40px;
    }
`;

export const RowContainer = styled(TableRow)`
    background-color: ${value('color.background.surface.middle')};
`;

export const CellContainer = styled(TableCell)`
    border: none;
    /* shorthand the following will override the inherited x-axis padding which is needed*/
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
    overflow-wrap: anywhere;

    &:first-child {
        padding-left: ${spacing(4)};
        border-top-left-radius: ${value('radius.m')};
        border-bottom-left-radius: ${value('radius.m')};
    }

    &:last-child {
        padding-right: ${spacing(4)};
        border-top-right-radius: ${value('radius.m')};
        border-bottom-right-radius: ${value('radius.m')};
    }
`;

export const SyncButtonContainer = styled.div`
    margin-left: -13px;
`;

export const AlignedRightCell = styled.div`
    display: flex;
    justify-content: flex-end;
`;

export const SearchContainer = styled.div`
    padding: ${spacing(3, 3, 2)};
    position: sticky;
    top: 0;
    background-color: ${value('color.background.surface.default')};
`;

export const AssignButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 8px;
    align-items: center;

    button {
        opacity: 0;
    }

    &:hover {
        button {
            transition: opacity ${transition('default')};
            opacity: 1;
        }
    }
`;

export const AssignButton = styled(Button)`
    padding: 0;
    width: 100%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;

    span {
        width: 100%;
        display: inline;
    }
`;

export const MenuContainer = styled.div`
    overflow: hidden;
    border-radius: ${radius('l')};
`;

export const MenuListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    max-height: 250px;
    max-width: 250px;
    overflow-y: auto;

    background-image: linear-gradient(white 30%, rgba(255, 255, 255, 0)),
        linear-gradient(rgba(255, 255, 255, 0), white 70%), linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0)),
        linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1));
    background-position: 0 0, 0 100%, 0 0, 0 100%;
    background-repeat: no-repeat;
    background-color: white;
    background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
    /* Opera doesn't support this in the shorthand */
    background-attachment: local, local, scroll, scroll;
`;

export const NoResults = styled.div`
  typography('body.base.default');
  padding: ${spacing(3)};
`;
